//client/src/pages/admin/AdminInternalOrdersCreate.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
import { toast } from "react-hot-toast";

export default function AdminInternalOrdersCreate() {
  const [services, setServices] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selected, setSelected] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [link, setLink] = useState("");

  useEffect(() => {
    api.get("/admin/services").then(res => {
      setServices(res.data || []);
      setFiltered(res.data || []);
    });
  }, []);

  const search = (q) => {
    q = q.toLowerCase();
    setFiltered(
      services.filter(
        s =>
          s.name.toLowerCase().includes(q) ||
          String(s.providerServiceId).includes(q)
      )
    );
  };

  const cost =
    selected && quantity
      ? ((selected.providerRate * quantity) / 1000).toFixed(2)
      : "0.00";

  const submit = async () => {
    if (!selected || !quantity || !link)
      return toast.error("All fields required");

    await api.post("/admin/internal-orders", {
      serviceId: selected._id,
      quantity: Number(quantity),
      link,
    });

    toast.success("Internal order placed");
    setSelected(null);
    setQuantity("");
    setLink("");
  };

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">Place Internal Order</h1>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="card-glass p-4">
          <input
            className="input-glass mb-3"
            placeholder="Search service"
            onChange={(e) => search(e.target.value)}
          />

          <div className="max-h-96 overflow-y-auto border border-white/10 rounded-lg">
            {filtered.map((s) => (
              <div
                key={s._id}
                onClick={() => {
                  setSelected(s);
                  setQuantity(s.min);
                }}
                className={`p-3 cursor-pointer border-b border-white/10 ${
                  selected?._id === s._id ? "bg-purple-800/40" : ""
                }`}
              >
                <div className="font-medium">
                  {s.providerServiceId} | {s.name}
                </div>
                <div className="text-xs text-gray-400">
                  ₹{s.providerRate}/1000
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card-glass p-4 space-y-3">
          <div>Service: <b>{selected?.name || "None"}</b></div>

          <input
            className="input-glass"
            placeholder="Link"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />

          <input
            className="input-glass"
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="Quantity"
          />

          <div className="text-sm text-gray-400">
            Provider Cost: ₹{cost}
          </div>

          <button onClick={submit} className="btn-primary w-full">
            Place Internal Order
          </button>
        </div>
      </div>
    </div>
  );
}
